import DateAndOrTimePicker from '@/Controls/DateAndOrTimePickerBase';
import ComponentManager from '@/Management/ComponentManager';
import DateAndTimePickerViewModelType from '@/ViewModels/Controls/DateAndTimePickerViewModel';
import * as DateHelper from '@/Utility/DateHelper'

export default class DateAndTimePicker extends DateAndOrTimePicker {
    public constructor(protected viewModel: DateAndTimePickerViewModelType, protected element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null)
            return this.jQueryControl;

        this.jQueryControl = this.createControl(this.element, 'datetime-local', 'k-textbox');

        this.widget(null);

        return this.jQueryControl;
    }

    protected onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'dateandtimepicker',
        });

        super.onWidgetCreatedCallback(widget);

        this.applyBindings(this.jQueryControl.find('input'), {
            attr: {
                min: this.defineComputed(() => {
                    return DateHelper.extractDateTimeFromDate(this.viewModel.min());
                }),
                max: this.defineComputed(() => {
                    return DateHelper.extractDateTimeFromDate(this.viewModel.max());
                })
            }
        });
    }
}

ComponentManager.setControl('DateAndTimePicker', DateAndTimePicker, 'RADPresentation.HTMLClient.DefaultViewExtensions');